<template>
  <div v-if="$can('create','add_candidates')">
    <div class="text-danger" v-if="error && error !== 'Candidate Added!'"> {{ error }}</div>
    <div class="text-success" v-if="error && error === 'Candidate Added!'"> {{ error }}</div>
    <textarea @paste="handlePaste" rows = "1" placeholder="Paste Data here"></textarea>
    <validation-observer ref="addCandidate">
    <b-form enctype="multipart/form-data">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>First Name*</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="First Name"
              
            >
              <b-form-input
                v-model="firstName"
                :state="errors.length > 0 ? false:null"
                placeholder="First Name"
                class="text-capitalize"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Last Name*</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Last Name"
              
            >
              <b-form-input
                v-model="lastName"
                :state="errors.length > 0 ? false:null"
                placeholder="Last Name"
                class="text-capitalize"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Company Name*</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Company Name"
              
            >
              <b-form-input
                v-model="companyName"
                :state="errors.length > 0 ? false:null"
                placeholder="Company Name"
                class="text-capitalize"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Job Title*</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Job Title"
            >
              <b-form-input
                v-model="jobTitle"
                :state="errors.length > 0 ? false:null"
                placeholder="Job Title"
                class="text-capitalize"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Email*</label>
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="required|email"
            >
              <b-form-input
                v-model="email"
                :state="errors.length > 0 ? false:null"
                placeholder="Email"
                @input="runCheck"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Contact Number*</label>
            <validation-provider
              #default="{ errors }"
              rules="required|digits:10"
              name="Numeric"
            >
              <b-form-input
                v-model="contactNumber"
                :state="errors.length > 0 ? false:null"
                placeholder="Contact Number"
                @input="runCheck"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small class="text-primary" @click="checkCandidateExist">{{ checkButton }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>CTC</label>
              <b-form-input
                v-model="ctc"
                placeholder="CTC"
                type="number"
                step=".01"
                trim
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Expected CTC</label>
             <b-form-input
                v-model="expCTC"
                placeholder="Expected CTC"
                type="number"
                step=".01"
                trim
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Experience</label>
             <b-form-input
                v-model="exp"
                placeholder="Experience"
                type="number"
                step=".01"
                trim
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Relevant Experience</label>
             <b-form-input
                v-model="relExp"
                placeholder="Relevant Experience"
                type="number"
                step=".01"
                trim
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Notice Period</label>
              <v-select
                    id="notice-period"
                    label="value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="noticePeriod"
                    :reduce="(option) => option.text"
                    ref="noticePeriod"
                    :options="noticePeriodOptions"
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Current Location</label>
              <v-select
                    id="current-location"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="currentLocation"
                    :reduce="(option) => option.title"
                    label="title"
                    :options="locationOptions"
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Preferred Location</label>
              <v-select
                    id="preferred-location"
                    label="title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="preferredLocation"
                    :reduce="(option) => option.title"
                    ref="preferredLocation"
                    :options="locationOptions"
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Skill</label>
              <v-select
                    id="select-skill"
                    label="title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="skillSelected"
                    :reduce="(option) => option.title"
                    :options="skillsOptions"
                    :disabled="true"
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Qualification</label>
              <v-select
                    id="select-qualification"
                    label="title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="qualificationSelected"
                    :reduce="(option) => option.title"
                    :options="qualificationOptions"
              />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Source *</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="Select Source"
              >
              <v-select
                    id="select-source"
                    label="title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="sourceSelected"
                    :reduce="(option) => option.title"
                    ref="select-source"
                    :options="sourceOptions"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
              
              <b-form-group>
                <label>DOB</label>
                <flat-pickr
                  class="form-control"
                  id="dob" 
                  v-model="dob" 
                  placeholder="YYYY-MM-DD"
                />
              </b-form-group>
          </b-col>
        <b-col md="6">
          <b-form-group>
            <label>Gender *</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Select Gender "
              >
              <v-select
                    id="select-gender"
                    label="title"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="genderSelected"
                    :reduce="(option) => option.title"
                    ref="select-gender"
                    :options="genderOptions"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Upload Resume" label-for="resume">
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                id="cv-file"
                name="cv-file"
                accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown"
                @change="openFile"
                v-model="file"
                type="file"
                ref="file"
              />
              <small v-if="file && file.size > 1690000" class="text-danger"> File Size Should be less than 1.5 mb </small>
          </b-form-group>      
        </b-col>
        <b-col md="6" xl="6" lg="6">
          <b-form-group label="Remarks" label-for="remarks">
            <b-form-textarea
              id="textarea-default"
              placeholder="Add Remark"
              rows="3"
              v-model="remarks"
            />
          </b-form-group>
        </b-col>
        
      </b-row>
      
        
      <b-button type="submit" variant="primary"
      @click.prevent="submitForm"
      >Add Candidate</b-button>
    </b-form>
  </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length
} from '@validations'
import { BFormFile, BButton, BFormGroup, BForm, BFormInput, BRow, BCol, BFormTextarea  } from "bootstrap-vue";
import vSelect from "vue-select";
import JobService from '@/services/job-service'
import CandidateService from '@/services/candidate-service'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import locationService from "@/services/location-service";
import adminConfigService from "@/services/admin-config-service";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BFormTextarea,
    BFormFile,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BRow,
    BCol,
    vSelect,
    flatPickr
  },
  data() {
    return {
      file: null,
      invalidFile: null,
      contactNumber: "",
      companyName: "",
      currentLocation: "",
      preferredLocation: "",
      jobTitle: "",
      email: "",
      firstName: "",
      lastName: "",
      ctc: null,
      expCTC: null,
      exp: null,
      noticePeriod: null,
      relExp: null,
      genderSelected: "",
      qualificationSelected: "",
      sourceSelected: "",
      skillSelected: "",
      remarks: "",
      dob: "",
      error: null,
      noticePeriodOptions: [
        { value: 'Immediate', text: 0 },
        { value: 15, text: 15 },
        { value: 30, text: 30 },
        { value: 45, text: 45 },
        { value: 60, text: 60 },
        { value: 90, text: 90 },
      ],
      locationOptions: [{"title":"PAN INDIA"},{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Remote"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
      qualificationOptions: [],
      genderOptions: [
        { title: "Male" },
        { title: "Female" },
        { title: "Transgender" },
        { title: "Non-binary/non-conforming" },
        { title: "Prefer not to respond" },
      ],
      sourceOptions: [
        { title: "Naukri" },
        { title: "Monster" },
        { title: "LinkedIn" },
        { title: "Indeed" },
        { title: "Shine" },
        { title: "TimesJobs" },
        { title: "IIMJobs" },
        { title: "Glassdoor" },
        { title: "FreshersWorld" },
        { title: "Other" },
        { title: "Train N Hire" },
        { title: "Internal" },
        { title: "Referenced" },
        { title: "MassMailer" },
      ],
      skillsOptions: [],
      errors: null,
      checkButton: 'Check if Exist',
    };
  },
  created() {
    this.isLoggedIn()
    JobService.getJobPositionList().then(res => {
      console.log(res.data)
      this.skillsOptions = res.data
    })
    locationService.getAll().then(res => {
      console.log(res.data)
      this.locationOptions = res.data
    })
  },
  
  methods: {
    handlePaste(e) {
      //console.log('handle paste', e)
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      console.log('paste data: ', clipboardData.getData('text'))
      const jsonData = JSON.parse(pastedData);
      try {
        
        
        // Assume jsonData has properties like { name: "John", email: "john@example.com"}
        // Loop through keys of jsonData and assign them to formData if they exist
        this.firstName = jsonData.firstName
        this.lastName = jsonData.LastName ? jsonData.LastName : '.'
        this.companyName = jsonData.companyName
        this.jobTitle = jsonData.jobTitle
        this.email = jsonData.email
        this.contactNumber = jsonData.contact
        this.ctc = jsonData.ctc
        this.exp = jsonData.exp
        this.qualificationSelected = jsonData.qualification
        this.genderSelected = jsonData.genderSelected
        this.currentLocation = jsonData.currentLocation ? jsonData.currentLocation : null
        this.dob = jsonData.dob ? this.formatDate(jsonData.dob) : null
        this.noticePeriod = jsonData.noticePeriod
        this.checkCandidateExist()
        //this.candidateData.lastName = jsonData.LastName ? jsonData.LastName : '.'
        // console.log(jsonData.dob)
        // this.candidateData.dob = jsonData.dob ? this.formatDate(jsonData.dob) : null
      } catch (error) {
        this.checkCandidateExist()
        console.error('Failed to parse JSON data:', error);
        // Handle error for invalid JSON data
      }
    },
    formatDate(dateStr) {
      const months = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
        Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
      };
      
      // Split the date string and destructure it into day, month, and year
      const [day, month, year] = dateStr.split(' ');

      // Zero-pad the day and convert the month string to month number
      const formattedDay = day.length === 1 ? `0${day}` : day;
      const formattedMonth = months[month];

      // Combine the parts into the desired format
      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;

      return formattedDate;
    },
    async submitForm() {
      if(!this.$can('create','add_candidates')) {
        return
      }
      console.log('submitting form')
      const isValid = await this.$refs.addCandidate.validate();
      this.$refs.addCandidate.validate().then(success => {
        console.log('submitting form in validate', success)
        if (success) {
          console.log('submitting form in success', success)
          // eslint-disable-next-line
          const formData = new FormData();
          if (this.file && this.file.size > 2010000) {
            alert("File size must be less than 1.5 MB");
            return;
          }
          const userData = JSON.parse(localStorage.getItem('userData'));
          const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
          if (this.file) formData.append("cvFile", this.file);
          formData.append('first_name', this.firstName)
          formData.append('last_name', this.lastName)
          formData.append('email', this.email.toLowerCase())
          formData.append('curr_company', this.companyName)
          formData.append('contact_no', parseInt(this.contactNumber))
          formData.append('curr_position', this.jobTitle)
          formData.append('curr_location', this.currentLocation)
          formData.append('pref_location', this.preferredLocation)
          formData.append('ctc', parseFloat(this.ctc))
          formData.append('exp_ctc', parseFloat(this.expCTC))
          formData.append('exp', parseFloat(this.exp))
          formData.append('relevant_exp', parseFloat(this.relExp))
          formData.append('notice_period', parseInt(this.noticePeriod))
          formData.append('skills', this.skillSelected)
          formData.append('source', this.sourceSelected)
          formData.append('qualification', this.qualificationSelected)
          formData.append('dob', this.dob ? this.dob : "1900-01-01")
          formData.append('gender', this.genderSelected)
          formData.append('status', 'FreePool')
          formData.append('created_by', user)
          formData.append('updated_by', user)
          formData.append('can_remarks', JSON.stringify(this.remarks))
          console.log('submitting form  details', formData)
          CandidateService.addCandidate(formData).then(res => {
            console.log('submitting form  response add candidate', res)
            if(res.status === "OK") {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Candidate Added to the Job Successfully',
                      icon: 'EditIcon',
                      variant: 'success',
                      timeout: 8000,
                    },
              })
              this.error = 'Candidate Added!'
              this.$refs.addCandidate.reset();
              //this.$router.push({ name: "apps-candidates-add"})
              this.clear();
            } else if ((res.status === 401 ) || (res.status === 403 )) {
                  window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                  localStorage.clear();
                  this.$router.push({ name: "auth-login" });
            } else if (res.status === 500 ) {
              this.error = 'ERROR: status code' + res.status + ' Status Text: ' + statusText + ' Error Message: ' + res.data.error ? res.data.error.errors[0].message : res.data.message 
            }else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Candidate Add to Job Failed !!!',
                      icon: 'EditIcon',
                      variant: 'danger',
                      timeout: 8000,
                    },
                  })
            }      
          })
            //alert('form submitted!')
        }
      })
      if(isValid) {
        this.$refs.addCandidate.reset();
      }
      // console.log('submitting form')
    },
    openFile(event) {
      console.log(event.target.files)
      if(event.target.files) {
        this.file = event.target.files[0];
        console.log("file", this.file);
        //console.log("cfile", this.candidateData.file)
      } else {
        this.invalidFile = true
        console.log(this.invalidFile)
      }
    },
    isLoggedIn() {
      const expireIn = localStorage.getItem('expireIn')
      if (Math.floor(Date.now() / 1000 > expireIn)) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          ////console.log("called logout")
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
      }
    },
    checkCandidateExist() {
      if(this.email && this.contact) {
        if(this.validateEmail(this.email) && this.contactNumber.length === 10) {
          CandidateService.checkCandidateExist(this.email, this.contactNumber).then(res => {
            console.log(res)
             if(res.status === "OK") {
                this.error.email = 'Candidate Already Exist in ATS'
                this.checkButton = 'Check if Exist'
             } else if (res.status === 400) {
                this.checkButton = 'Fresh Candidate'
                this.error.email = null
                this.error.contact = null
             }
          })
        } else {
          this.error.email = 'Please enter valid email'
          this.error.contact = 'Please enter valid contact number 10 digit'
          this.checkButton = null
        }
      } else if (!this.email || !this.contactNumber) {
        if (!this.email || !this.validateEmail(this.email)) {
          this.error.email = 'Please enter valid email'
        }
        if (!this.contactNumber || !this.contactNumber.length !== 10) {
          this.error.contact = 'Please enter valid contact no(10 digits required)'
        }
      } 
    },
    runCheck() {
      console.log('in check')
      this.checkCandidateExist()
    },
    validateEmail(email){
      return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    prefillFromQuery() {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      if (q.phone) {
        const digits = String(q.phone).replace(/\D/g, '')
        this.contactNumber = digits.length > 10 ? digits.slice(-10) : digits
      }
      if (q.fname) this.firstName = q.fname
      if (q.lname && q.lname !== '.') this.lastName = q.lname
      if (q.source) {
        const match = this.sourceOptions.find(
          s => s.title && s.title.toLowerCase() === String(q.source).toLowerCase(),
        )
        if (match) this.sourceSelected = match.title
      }
      if (q.remarks) this.remarks = q.remarks
    },
    clear() {
      this.file = null
      this.invalidFile = null
      this.contactNumber = ""
      this.companyName = ""
      this.currentLocation = ""
      this.preferredLocation = ""
      this.jobTitle = ""
      this.email = ""
      this.firstName = ""
      this.lastName = ""
      this.ctc = null
      this.expCTC = null
      this.exp = null
      this.noticePeriod = null
      this.relExp = null
      this.genderSelected = ""
      this.qualificationSelected = ""
      this.sourceSelected = ""
      this.skillSelected = ""
      this.remarks = ""
      this.dob = ""
      this.error = null
      this.errors = null
    }
  },
  mounted() {
    adminConfigService.getATSDropdownList().then(res => {
      if(res.status === 200) {
        this.sourceOptions = res.data.data.sourceList
        this.qualificationOptions = res.data.data.qualificationList
      }
      this.prefillFromQuery()
    })
  }
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
